import 'leaflet'
import 'leaflet.markercluster'

import BaseDrawer from '@/utils/map/BaseDrawer'
import { map as mapEndpoints } from '@/api/api-endpoints'
import GarageImage from '../../../assets/images/icons/mps.png'
import OROImage from '../../../assets/images/icons/oro.png'

const GarageIcon = L.icon({
  iconSize: [30, 30],
  iconUrl: GarageImage,
  iconAnchor: [15, 15],
})
const OROIcon = L.icon({
  iconSize: [30, 30],
  iconUrl: OROImage,
  iconAnchor: [15, 15],
})

class RoutesDrawer extends BaseDrawer {
  constructor(map, vm, options) {
    super(map, vm, options)
    this.routeLayer = L.featureGroup()
    this.routeLayer.addTo(map)
    if (!this.markerLayer) {
      this.markerLayer = L.markerClusterGroup({
        chunkedLoading: true,
        chunkInterval: 200, // process markers for a maximum of ~ n milliseconds (then trigger the chunkProgress callback)
        chunkDelay: 50, // at the end of each interval, give n milliseconds back to system/browser
        chunkProgress: null,
        iconCreateFunction: (cluster) =>
          L.divIcon({
            className: 'cluster-marker msn',
            html: cluster.getChildCount(),
            iconSize: [36, 36],
            iconAnchor: [18, 18],
          }),
        showCoverageOnHover: false,
        markersInLayer: [],
      })
      this.markerLayer.on('spiderfied', function (a) {
        if (a.cluster && a.cluster.options && a.cluster.options.icon) {
          a.cluster.options.icon.setOpacity(0)
        }
      })
      this._map.addLayer(this.markerLayer)
    } else {
      this.removeMarkers()
    }
    this.waitForPoint = false
  }

  onMarkerClick(e, marker) {
    let {
      options: {
        model: { id },
      },
    } = marker
    if (this.waitForPoint && this.greenMSNIds.indexOf(+id) === -1) {
      this.$emitter.emit('marker.click', {
        marker,
        e,
      })
    } else {
      super.onMarkerClick(e, marker)
    }
  }

  removeRoute() {
    if (this.routeLayer) {
      this.routeLayer.clearLayers()
    }
  }

  removeMarkers() {
    if (this.markerLayer) {
      this.markerLayer.clearLayers()
    }
    this._markers = {}
  }

  removeAll() {
    this.greenMSNIds = []
    this.removeRoute()
    this.removeMarkers()
  }

  async drawRoute(inputOpenedRoute, inputMSNs = [], inputRouteMsns = {}) {
    await this.drawPoints(
      this.dropVueWatchers(inputMSNs),
      this.dropVueWatchers(inputRouteMsns)
    )

    let openedRoute = this.dropVueWatchers(inputOpenedRoute)
    await this.drawPoint(openedRoute)
    await this.drawEndPoint(openedRoute)
    let passedRoute = []
    if (openedRoute.polyline && openedRoute.polyline.length > 0) {
      openedRoute.polyline.forEach((v) => {
        passedRoute.push(L.latLng([v[1], v[0]]))
      })
    }
    if (passedRoute.length > 0) {
      this.routeLayer.addLayer(
        new L.polyline(passedRoute, {
          color: 'red',
          weight: 3,
          opacity: 0.5,
          smoothFactor: 1,
        })
      )
    }
  }

  drawStartPoint(openedRoute) {
    if (
      openedRoute.startPoint &&
      openedRoute.startPoint.coords &&
      openedRoute.startPoint.coords[0]
    ) {
      // TODO:
      this.startPoint = L.marker(openedRoute.startPoint.coords, {
        icon: GarageIcon,
      })
      this.routeLayer.addLayer(this.startPoint)
      this.startPoint.bindTooltip(
        `Начальная точка ${openedRoute.start_point_address}`
      )
    }
  }

  drawPoint(point) {
    if (point.startPoint && point.startPoint.coords.length === 0) {
      return
    }
    if (!point.startPoint?.coords[0]) {
      return
    }
    const startPoint = L.marker(point.startPoint.coords, {
      icon: GarageIcon,
    })
    this.routeLayer.addLayer(startPoint)
    startPoint.bindTooltip(`Начальная точка ${point.start_point_address}`)
  }

  drawEndPoint(openedRoute) {
    if (
      openedRoute.endPoint &&
      openedRoute.endPoint.coords &&
      openedRoute.endPoint.coords[0]
    ) {
      // TODO:
      this.endPoint = L.marker(openedRoute.endPoint.coords, {
        icon: OROIcon,
      })
      this.routeLayer.addLayer(this.endPoint)
      this.endPoint.bindTooltip(
        `Конечная точка ${openedRoute.endPoint.address}`
      )
    }
  }

  zoomToRoute() {
    if (this.routeLayer && this.routeLayer.getLayers().length > 0) {
      this._map.fitBounds(this.routeLayer.getBounds(), {
        padding: [100, 100],
      })
    }
  }

  async drawPoints(inputMSNs = [], inputRouteMsns = {}) {
    this.removeMarkers()
    if (!inputMSNs?.length) {
      return
    }
    let msns = this.dropVueWatchers(inputMSNs)
    this.greenMSNIds = []
    if (Object.keys(inputRouteMsns).length > 0) {
      Object.values(inputRouteMsns).forEach((v) => {
        if (v) {
          this.greenMSNIds.push(+v.id)
        }
      })
    }
    if (msns) {
      let points = JSON.parse(JSON.stringify(msns))
      if (points.length > 0) {
        points.forEach((v) => {
          let iconType =
            this.greenMSNIds.indexOf(+v.id) > -1
              ? 'container'
              : 'container-gray'
          let model = Object.assign(v, {
            id: v.id,
            lat: v.latitude,
            lng: v.longitude,
            layerConfig: {
              iconType: 'places',
              endpoint: mapEndpoints.msn,
            },
            subLayerConfig: {
              iconType,
              showMore: true,
            },
          })

          this.drawMarker(model, { attachToLayer: this.markerLayer })
        })
      }
    }
  }
}

export default RoutesDrawer
